module.exports = __webpack_public_path__ + "img/find-user-male.6027f41b.png";